import { createReducer } from "typesafe-actions";

import CoachingFile from "@app/scene/dashboard/types/CoachingFile";

import {
  CoachingFilesActions,
  deleteCoachingFile,
  fetchCoachingFiles,
  updateCoachingFileTags,
  uploadCoachingFiles,
} from "./actions";

export interface CoachingFilesState {
  deleteLoadingIds: Array<CoachingFile["id"]>;
  files: CoachingFile[];
  loading: boolean;
  tagUpdateLoadingIds: Array<CoachingFile["id"]>;
  uploadLoading: boolean;
}

export const initialCoachingFilesState: CoachingFilesState = {
  deleteLoadingIds: [],
  files: [],
  loading: false,
  tagUpdateLoadingIds: [],
  uploadLoading: false,
};

const coachingFiles = createReducer<CoachingFilesState, CoachingFilesActions>(
  initialCoachingFilesState
)
  .handleAction(fetchCoachingFiles.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchCoachingFiles.success, (state, { payload }) => ({
    ...state,
    files: payload,
    loading: false,
  }))
  .handleAction(fetchCoachingFiles.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(uploadCoachingFiles.request, (state) => ({
    ...state,
    uploadLoading: true,
  }))
  .handleAction(uploadCoachingFiles.success, (state, { payload }) => ({
    ...state,
    files: [...payload, ...state.files],
    uploadLoading: false,
  }))
  .handleAction(uploadCoachingFiles.failure, (state) => ({
    ...state,
    uploadLoading: false,
  }))
  .handleAction(updateCoachingFileTags.request, (state, { payload }) => ({
    ...state,
    tagUpdateLoadingIds: [...state.tagUpdateLoadingIds, payload.id],
  }))
  .handleAction(updateCoachingFileTags.success, (state, { payload }) => ({
    ...state,
    files: state.files.map((file) => (file.id === payload.id ? payload : file)),
    tagUpdateLoadingIds: state.tagUpdateLoadingIds.filter((id) => id !== payload.id),
  }))
  .handleAction(updateCoachingFileTags.failure, (state, { payload }) => ({
    ...state,
    tagUpdateLoadingIds: state.tagUpdateLoadingIds.filter((id) => id !== payload),
  }))
  .handleAction(deleteCoachingFile.request, (state, { payload }) => ({
    ...state,
    deleteLoadingIds: [...state.deleteLoadingIds, payload.id],
  }))
  .handleAction(deleteCoachingFile.success, (state, { payload }) => ({
    ...state,
    deleteLoadingIds: state.deleteLoadingIds.filter((id) => id !== payload.id),
    files: state.files.filter((file) => file.id !== payload.id),
  }))
  .handleAction(deleteCoachingFile.failure, (state, { payload }) => ({
    ...state,
    deleteLoadingIds: state.deleteLoadingIds.filter((id) => id !== payload),
  }));

export default coachingFiles;
